import SubtitleText from 'components/text/SubtitleText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DrawerTitleText: FunctionComponent<Props> = props => {
    const { children = props.text, className = '', testId = TEST_ID } = props;

    return (
        <SubtitleText className={`${className} ${styles.drawerTitleText}`} testId={testId}>
            {children}
        </SubtitleText>
    );
};

export default DrawerTitleText;
